<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">
                Limitations and Disclaimer
              </div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                For Authorised Person
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container class=" white-background mb-5 pb-5 min-height">
        <v-layout column wrap class="mb-5" align-center>
          <v-flex xs12>
            <div class="text-xs-center">
              <h2 class="headline pa-2 ">Limitations and Disclaimer</h2>
              <span class="subheading pa-2">
                North Queensland Strata Title Inspection Program</span
              >
            </div>
            <div>
              <p class="pl-3 pr-3 pt-3">
                Participation in the North Queensland Strata Inspection Program
                is voluntary.
              </p>
              <span class="subheading pa-3 font-weight-bold"> Limitations</span>
              <p class="pl-3 pr-3 pt-3">
                A trained inspector will assess the grounds and buildings on
                your property. The report will contain general information only
                about the estimated resilience of your property to damage from
                tropical cyclones. It should not be considered as an assessment
                by a structural engineer or a replacement for professional
                advice specific to the strata property. JCU will take reasonable
                steps to ensure that the information contained in the report is
                accurate. The report will not comment on the assessment or
                detection of structural vulnerabilities that were concealed or
                in areas where access or entry was prevented or not possible at
                the time of inspection. Further detailed building inspections
                and assessments may be required in some situations.
              </p>

              <p class="pl-3 pr-3">
                It should be noted that during any cyclone, the damage that
                could be sustained by your property will depend on the features
                in your property and a number of other factors including:
              </p>
              <ul class="pl-5 pr-3 pb-3">
                <li>
                  The amount and type of wind-borne debris from nearby
                  properties;
                </li>
                <li>
                  Characteristics of the cyclone including the wind speed,
                  direction and duration;
                </li>
                <li>
                  The preparation of your property before the cyclone arrives.
                </li>
              </ul>
            </div>

            <div>
              <span class="subheading pa-3 font-weight-bold">
                Disclaimer of Liability</span
              >
              <p class="pa-3">
                By agreeing to participate in this program the Body Corporate
                acknowledges and agrees that JCU does not warrant the accuracy
                of the report and will have no liability in tort, negligence, or
                contract for property damage or financial loss suffered or
                incurred by any person or to any property, as a result of any
                actions taken or not taken in reliance on the contents of this
                report.
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <Footer :absolute="true"></Footer>
  </v-content>
</template>

<style>
  .min-height{
    min-height: 1300px !important;

  }
</style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";

export default {
  name: "Wind",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    size: "sm",
    cycle: false
  }),
  methods: {}
};
</script>
